import React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

const InsightsIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M20 8.08008L13.0909 15.1171L9.45455 11.4134L4 16.969M20 8.08008H15.6364M20 8.08008V12.5245"
            stroke={props.htmlColor || "#BDBDBD"}
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

export default InsightsIcon;
